import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CandidateCard from "../../components/candidates/condensed_card.js";
import {
  RolesLoading,
  CandidateCardLoading,
} from "../../components/loading/loading_interviews.js";

export default function InProcess() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [loadingCandidates, setLoadingCandidates] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState();
  const [filter, setFilter] = useState("");
  const [roles, setRoles] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [activeRole, setActiveRole] = useState("");
  const [interviewNeedUpdate, setInterviewNeedUpdate] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [showFinalPopup, setShowFinalPopup] = useState(false);
  const [candidatesRequest, setCandidatesRequest] = useState(0);
  const [isRequested, setIsRequested] = useState(true);

  const handleSelectCandidate = (candidate) => {
    setSelectedCandidate(candidate);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/passwordless-login");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get("/api/roles/fetchRoles", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const roles = response.data.roles;

        const transformedData = roles.map((role) => {
          return {
            id: role.id,
            title: role["Role Title"],
            status: role["Open to applications"] === "Open to apps" ? true : false,
          };
        });

        setRoles(transformedData);
        setLoadingRoles(false);
      } catch (err) {
        setError(err.message);
        setLoadingRoles(false);
      }
    };

    const transformRoles = (roles) => {
      const roleSet = new Set(roles);
      if (roleSet.size === 1) {
        if (roleSet.has("Full Stack Developer")) return ["Full Stack"];
        if (roleSet.has("Front End Developer")) return ["Front End"];
        if (roleSet.has("Back End Developer")) return ["Back End"];
      }
      if (
        roleSet.has("Front End Developer") &&
        roleSet.has("Back End Developer")
      ) {
        return ["Full Stack"];
      }
      if (roleSet.has("Full Stack Developer")) {
        return ["Full Stack"];
      }
      return roles;
    };

    const fetchInterviews = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get("/api/interviews/fetchInterviews", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const interviews = response.data.interviews;
     
        // Filter only interviews where stage is "Interviewing" or "Offer made"        
        const filteredInterviews = interviews.filter((interview) => {
          const stage = interview.fields["Stage"];
          const isIncluded = ["Interviewing", "Offer made"].includes(stage);
          console.log(`Interview ${interview.id}: stage="${stage}", included=${isIncluded}`);
          return isIncluded;
        });
     

        let transformedCandidate = [];
        try {
          transformedCandidate = filteredInterviews.map((interview, index) => {
          console.log(`Transforming interview ${index + 1}/${filteredInterviews.length}:`, interview.id);
          console.log("Interview stage:", interview.fields?.["Stage"]);
          
          try {

          const stream =
            interview.fields?.["Stream (from CRM) (from Candidate)"][0];

          let sweRoles =
            interview.fields["SWE relevant roles (from Candidate)"];
          if (sweRoles) {
            sweRoles = Array.isArray(sweRoles)
              ? sweRoles[0].split(",").map((role) => role.trim())
              : sweRoles.split(",").map((role) => role.trim());
            sweRoles = transformRoles(sweRoles);
          } else {
            sweRoles = [];
          }
          console.log("interview");

                      const candidate = {
              role: Array.isArray(interview.fields?.["Role"])
                ? interview.fields["Role"][0]
                : undefined,
            ranking: interview.fields?.["Ranking"] || undefined,
            role_title: Array.isArray(
              interview.fields?.["Role Title (from Role)"]
            )
            ? interview.fields["Role Title (from Role)"][0]  // Fixed field reference
            : undefined,
            interviewId: interview.fields?.["id"] || undefined,
            url_id: interview.fields?.["ID (from Candidate)"] || undefined,
            stage: interview.fields?.["Stage"] || undefined,
            linkedin: Array.isArray(
              interview.fields?.["LinkedIn RAW (from Candidate)"]
            )
              ? interview.fields["LinkedIn RAW (from Candidate)"][0]
              : undefined,
            cv: Array.isArray(interview.fields?.["CV RAW (from Candidate)"])
              ? interview.fields["CV RAW (from Candidate)"][0]
              : undefined,
            name: Array.isArray(interview.fields?.["Name (from Candidate)"])
              ? interview.fields["Name (from Candidate)"][0]
              : undefined,
            lastName: Array.isArray(
              interview.fields?.["Surname (from Candidate)"]
            )
              ? interview.fields["Surname (from Candidate)"][0]
              : undefined,
            video: Array.isArray(
              interview.fields?.["Video intro (new) From (ALL CANDIDATE PROFILES)"]
            )
              ? interview.fields["Video intro (new) From (ALL CANDIDATE PROFILES)"][0]
              : undefined,
            undergrad_degree_type:
              interview.fields?.["Undergrad degree type (from Candidate)"] ||
              "",
            undergrad_degree_subject:
              interview.fields?.["Undergrad subject (from Candidate)"] || "",
            undergrad_university:
              interview.fields?.["Undergrad university (from Candidate)"] || "",
            undergrad_graduation_year:
              interview.fields?.[
                "Undergrad graduation year (from Candidate)"
              ] || "",
            undergrad_result:
              interview.fields?.["Undergrad result (from Candidate)"] || "",
            postgrad_degree_type:
              interview.fields?.["Postgrad degree type (from Candidate)"] || "",
            postgrad_degree_subject:
              interview.fields?.["Postgrad subject (from Candidate)"] || "",
            postgrad_university:
              interview.fields?.["Postgrad university (from Candidate)"] || "",
            postgrad_graduation_year:
              interview.fields?.["Postgrad graduation year (from Candidate)"] ||
              "",
            postgrad_result:
              interview.fields?.["Postgrad result (from Candidate)"] || "",
            roles:
              interview.fields?.[
                "Generalist roles suitable for copy (from Candidate)"
              ] || undefined,
            email: Array.isArray(interview.fields?.["Email (from Candidate)"])
              ? interview.fields["Email (from Candidate)"][0]
              : undefined,
            working_style:
              interview.fields?.[
                "Preferred working style copy (from Candidate)"
              ] || undefined,
            image:
              interview.fields?.["Photo (from Candidate)"]?.[0]?.url ||
              undefined,
            work_experience_1_role:
              interview.fields?.["(1) Work Experience Role (from Candidate)"] ||
              "",
            work_experience_1_company:
              interview.fields?.[
                "(1) Work Experience Company (from Candidate)"
              ] || "",
            work_experience_1_description:
              interview.fields?.[
                "(1) Work Experience Description (from Candidate)"
              ] || "",
            work_experience_1_duration: {
              years: interview.fields?.["(1) Time spent in work experience YRS NEW (from Candidate)"] || 0,
              months: interview.fields?.["(1) Time spent in work experience MOS NEW (from Candidate)"] || 0,
            },
            work_experience_2_role:
              interview.fields?.["(2) Work Experience Role (from Candidate)"] ||
              "",
            work_experience_2_company:
              interview.fields?.[
                "(2) Work Experience Company (from Candidate)"
              ] || "",
            work_experience_2_description:
              interview.fields?.[
                "(2) Work Experience Description (from Candidate)"
              ] || "",
            work_experience_2_duration: {
              years: interview.fields?.["(2) Time spent in work experience YRS NEW (from Candidate)"] || 0,
              months: interview.fields?.["(2) Time spent in work experience MOS NEW (from Candidate)"] || 0,
            },
            languages:
              interview.fields?.["Languages copy (from Candidate)"] ||
              undefined,
            description:
              interview.fields?.["Top achievement (from Candidate)"] ||
              undefined,
            mostRecentCohort: Array.isArray(
              interview.fields?.["Most recent cohort (from Candidate)"]
            )
              ? interview.fields["Most recent cohort (from Candidate)"][0]
              : undefined,
            recentTarget:
              interview.fields?.["Recent target achieved (from Candidate)"] ||
              undefined,
            stream: stream || undefined, // Add the stream field
            rationale: interview.fields?.["Application Rationale"] || undefined,
            sales:
              interview.fields?.[
                "Proven Sales Experience / High Potential for Sales (from Candidate)"
              ] || undefined,
            github: Array.isArray(
              interview.fields?.["Github RAW (from Candidate)"]
            )
              ? interview.fields["Github RAW (from Candidate)"][0]
              : "",
            exp_swe:
              interview.fields?.["Level of exp SWE (from Candidate)"] || "",
            portfolio: Array.isArray(
              interview.fields?.["Raw Portfolio (from Candidate)"]
            )
              ? interview.fields["Raw Portfolio (from Candidate)"][0]
              : "",
            time_coding:
              interview.fields?.["Time spent coding (from Candidate)"] || "",
            coding_languages: Array.isArray(
              interview.fields?.["Coding languages new (from Candidate)"]
            )
              ? interview.fields["Coding languages new (from Candidate)"] || ""
              : "",

            swe_roles: sweRoles,
            minimum_salary:
              interview.fields?.["Minimum salary (from Candidate)"] || "",
            ideal_salary:
              interview.fields?.["Ideal salary (from Candidate)"] || "",
            right_to_work:
              interview.fields?.["RTW doc (from Candidate)"] || "",
          };
          
          console.log("Transformed candidate:", candidate);
          return candidate;
          } catch (error) {
            console.error(`Error transforming interview ${interview.id}:`, error);
            return null;
          }
        }).filter(candidate => candidate !== null);
        } catch (error) {
          console.error("Error in transformation process:", error);
          transformedCandidate = [];
        }

        console.log("About to set candidates with:", transformedCandidate.length, "candidates");
        console.log("First candidate sample:", transformedCandidate[0]);
        
        try {
          setCandidates(transformedCandidate);
          console.log("setCandidates called successfully");
        } catch (error) {
          console.error("Error setting candidates:", error);
        }
        
        console.log("Final transformed candidates:", transformedCandidate);
        console.log("Candidates count:", transformedCandidate.length);

        const requestCount = transformedCandidate.filter(
          (candidate) => candidate.stage === "Application pending"
        ).length;
        setCandidatesRequest(requestCount);

        setLoadingCandidates(false);
      } catch (err) {
        if (
          err.response &&
          err.response.data &&
          err.response.data.message === "Internal Server Error" &&
          err.response.data.error ===
            "Error: No interviews found for this company"
        ) {
          setCandidates([]); // Set empty state
          setLoadingCandidates(false);
        } else {
          setError(err.message);
          setLoadingCandidates(false);
        }
      }
    };

    if (!interviewNeedUpdate) return;

    fetchRoles();
    fetchInterviews();
    setInterviewNeedUpdate(false);
  }, [interviewNeedUpdate]);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  console.log("Current candidates state:", candidates);
  console.log("Candidates state length:", candidates.length);
  console.log("Filter state:", filter);
  console.log("Active role state:", activeRole);
  
  const filteredData = candidates.filter((candidate) => {
    console.log(`Filtering candidate: ${candidate.name}, stage: ${candidate.stage}, role: ${candidate.role}`);
    if (filter && candidate.stage !== filter) {
      console.log(`Excluded by stage filter: ${candidate.name}`);
      return false;
    }
    if (activeRole && candidate.role_title !== activeRole) {
      console.log(`Excluded by role filter: ${candidate.name}`);
      return false;
    }
    console.log(`Included: ${candidate.name}`);
    return true;
  });
  
  console.log("Final filtered data count:", filteredData.length);

  // Count candidates by role
  const candidatesByRole = {};
  candidates.forEach(candidate => {
    if (candidate.role_title) {
      candidatesByRole[candidate.role_title] = (candidatesByRole[candidate.role_title] || 0) + 1;
    }
  });



  return (
    <>
      <div className="relative bg-white min-h-screen">
        <div>
          <div className="flex lg:ml-[200px] h-full pb-20 justify-center bg-white">
            <div className="w-full max-w-[1500px]">
              <div className="bg-white pl-4 lg:pl-12 px-4 pt-6 pb-4 fixed top-18 z-20 w-full border-b">
                <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center">
                  <div>
                    <h2 className="text-2xl lg:text-3xl">In process</h2>
                    <div className="flex flex-col lg:flex-row lg:items-center mt-2 lg:mt-0">
                      <p className="mb-3 lg:mb-0 lg:mr-6 text-sm lg:text-md">
                        You are currently interviewing{" "}
                        <span className="font-bold">{filteredData.length}</span>{" "}
                        candidates.
                      </p>
                      <div className="flex flex-col lg:flex-row lg:items-center space-y-2 lg:space-y-0">
                        <div>
                          <label htmlFor="role-filter" className="sr-only">Filter by role</label>
                          <select
                            id="role-filter"
                            value={activeRole}
                            onChange={(e) => setActiveRole(e.target.value)}
                            className="border p-2 rounded-md text-sm w-full lg:w-36"
                          >
                            <option value="">Filter by Role</option>
                            {Object.entries(candidatesByRole).map(([roleTitle, count]) => (
                              <option key={roleTitle} value={roleTitle}>
                                {roleTitle} ({count})
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="flex justify-center pt-[180px] lg:pt-44 px-4 lg:pl-4">
                {/* Main content with candidate cards or "No candidates" message */}
                <div className="w-full max-w-[1500px]">
                  {loadingCandidates ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 ml-2 lg:ml-4">
                      {Array(6)
                        .fill(0)
                        .map((_, index) => (
                          <CandidateCardLoading key={index} />
                        ))}
                    </div>
                  ) : candidates.length === 0 ? (
                    <div className="flex justify-center px-4">
                      <div className="mt-2 bg-white w-full max-w-xl rounded-lg p-4 lg:p-6 shadow-sm text-center">
                        <div className="flex justify-center mb-4">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12 text-gray-400">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                          </svg>
                        </div>
                        <h2 className="text-lg lg:text-xl font-medium mb-2">
                          You don't have any in process candidates yet!
                        </h2>
                        
                        {/* Call to action buttons */}
                        <div className="mt-4 flex flex-col lg:flex-row gap-2 lg:gap-0 justify-center">
                          <button
                            onClick={() => {
                              setShowFinalPopup(false);
                              navigate("/browse-candidates");
                            }}
                            className="px-4 py-2 bg-[#02B491] text-white rounded-md hover:bg-[#02a082] transition-colors lg:mr-3 text-base font-medium w-full lg:w-auto"
                          >
                            Browse Candidates
                          </button>
                          <button
                            onClick={() => {
                              setShowFinalPopup(false);
                              navigate("/applications");
                            }}
                            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors text-base font-medium w-full lg:w-auto"
                          >
                            View applications
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 ml-2 lg:ml-4">
                      {filteredData.map((candidate, index) => (
                        <CandidateCard
                          key={index}
                          candidate={candidate}
                          onSelectCandidate={handleSelectCandidate}
                          setInterviewNeedUpdate={setInterviewNeedUpdate}
                          setShowPopup={setShowPopup}
                          setShowFinalPopup={setShowFinalPopup}
                          candidatesRequest={candidatesRequest}
                          setCandidatesRequest={setCandidatesRequest}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
